import { render, staticRenderFns } from "./CobroFacturasRP.vue?vue&type=template&id=01d52325&"
import script from "./CobroFacturasRP.vue?vue&type=script&lang=js&"
export * from "./CobroFacturasRP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports